import { useSelector } from 'react-redux';
import * as EventService from 'services/event';

export const useEventsService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createEvent = async (options = {}) => {
    const { payload } = await EventService.create({ ...options, token });
    return { event: payload };
  };

  const fetchEvent = async (id, options = {}) => {
    const { payload } = await EventService.readById(id, { ...options, token });
    return payload;
  };

  const fetchEvents = async (options = {}) => {
    const { error, payload } = await EventService.read({ ...options, token });
    if (error) {
      return { events: [], size: 0 };
    }

    const {
      data: events,
      meta: { size }
    } = payload;
    return { events, size };
  };

  const isCustomEvent = (event) => {
    return event && event.type === 'user';
  };

  const searchEvents = async (keys, keyword, options = {}) => {
    const { error, payload } = await EventService.search(keys, keyword, { ...options, token });
    if (error) {
      return { events: [], size: 0 };
    }

    const {
      data: events,
      meta: { size }
    } = payload;
    return { events, size };
  };

  const updateEvent = async (id, options = {}) => {
    const { payload } = await EventService.updateById(id, { ...options, token });
    return { event: payload };
  };

  const removeEvent = async (id) => {
    const { error } = await EventService.deleteOne(id, { token });
    return !error;
  };

  return {
    createEvent,
    fetchEvent,
    fetchEvents,
    isCustomEvent,
    removeEvent,
    searchEvents,
    updateEvent
  };
};
